import React from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

interface LayoutProps {
  children: React.ReactNode;
  toggleTheme: () => void;
  isDarkMode: boolean;
  userEmail: string | null;
  setUserEmail: (email: string | null) => void;
}

const Main = styled(Box)`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.palette.background.default};
  position: relative;
`;

const Content = styled(Box)<{ $isAuthPage?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
  ${({ $isAuthPage }) => !$isAuthPage && `
    padding-top: 64px;
    padding-bottom: 2rem;
  `}
`;

const Layout: React.FC<LayoutProps> = ({ children, toggleTheme, isDarkMode, userEmail, setUserEmail }) => {
  const location = useLocation();
  const isAuthPage = location.pathname === '/auth';

  return (
    <Main>
      <Header 
        toggleTheme={toggleTheme} 
        isDarkMode={isDarkMode} 
        userEmail={userEmail}
        setUserEmail={setUserEmail}
      />
      <Content $isAuthPage={isAuthPage}>{children}</Content>
      <Footer />
    </Main>
  );
};

export default Layout; 